export default {
  expiresSoon: 'Prístup k "{appName}" bude deaktivovaný po {expiryDate}.',
};
